// extracted by mini-css-extract-plugin
export default {"mCard":"AC-z","image":"BC-z","imageNoBackground":"CC-z","imageHasCategory":"DC-z","fullWidth":"EC-z"};